<script>
  import Layout from "../../layouts/main";
  import Style from "@/views/layouts/style";
  import PageHeader from "@/components/Page-header";
  import appConfig from "@/../app.config";
  import CheckModal from "@/components/CheckModal"
  import Pagination from "@/components/standard/Accident/NotAccidentPagination";
  import DontExist from "@/components/company/components/DontExist"
  import { required, minLength } from 'vuelidate/lib/validators'
  import { dateFormat } from "@/utils/helpers/format";
  import Swal from "sweetalert2";
  import CompanyAPI from "@/services/company/companyAPI";
  import EmployeeAPI from "@/services/employee/employeeAPI";
  import ItemAPI from "@/services/items/itemsAPI";
  import accidentAPI from "@/services/standards/accident/accidentAPI";

  export default {
    page: {
      title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
      meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
      Layout,
      Style,
      PageHeader,
      CheckModal,
      Pagination,
      DontExist,
    },
    data() {
      return {
        submi: false,
        title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales ",
        items: [

          {
            text: "Estandares",
            href: "/forms/estandares",
          },
          {
            text: "Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
            active: true,
          },
        ],
        noAccidents: {
          report_date: new Date().toISOString().substr(0, 10),
          description: null,
          companies_id: this.$store.getters["company/getCompany"].id || null,
        },
        lista: [],
        usersList: [],
        loading: true,
        loading1: true,
        search: "",
        itemData: null,
        submitted: false,
        classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      }
    },
    validations: {
      noAccidents: {
        report_date: {
          required,
        },
        description: {
          required,
        },
      }
    },
    methods: {
      fetch() {
        this.loading = true;
        this.$refs.paginator.query();
      },

      getList() {
        accidentAPI.notAccidents(this.$store.getters["company/getCompany"].id || null)
          .then((response) => {
            console.log('aqui', response)
            let accidente = response.Accident_report.data;
            this.lista = accidente
            console.log('lista',this.lista)

            this.loading1 = false

          })
          .catch((error) => {
            console.log(error);

          });
      },

      save() {
        this.submitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        } else {
          accidentAPI.saveNotAccident(this.noAccidents)
          .then((response) => {
            Swal.fire({
              title: "¡Se ha registrado con éxito!",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            setTimeout(() => {window.location.reload()}, 2000)
          })
          .catch(error => {
            console.log(error)
          })
        }
      },

      deleteAccident(id) {
        accidentAPI.deleteNotAccident(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => {window.location.reload()}, 1000)
        })
        .catch((error) => {
          console.log(error);
        });
      },

      allowAccess() {
        try {
          const item = this.itemData;

          if (item) {
            const classificationID =
              this.$store.getters["company/getCompany"].company_classification_id || null;

            if (classificationID === 1 && item.obligatory_UPA === 1) {
              return true;
            } else if (classificationID === 2 && item.obligatory_groupI === 1) {
              return true;
            } else if (classificationID === 3 && item.obligatory_groupII === 1) {
              return true;
            } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
          return false;
        }
      },

      getRole(name, roles) {
        // Get the user role
        let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

        // If the user is logged
        if (role) {
          // If the roles array is not empty
          if (roles) {
            // Know if the role indicated is in the roles array
            role = roles.includes(role) ? true : false

          } // Close if the roles arrays is not empty

          // If the roles arrays is empty
          else {
            // Know if the user role is in the roles indicated
            role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

          } // Close if the roles arrays is empty

          // Get the user permissions
          const permissions = this.$store.state.auth.info.permissions

          // Know if the user has the permission indicated
          const enabled = permissions.find(permission => permission.name === name)

          // If the user has the permission indicated and the user role is in the roles indicated
          return enabled && role ? true : false

        } // Close if the user is logged

        // If the user is not logged
        else {
          return false
        } // Close else the user is not logged
      },

      getUsers() {
        CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
          .then((response) => {
            EmployeeAPI.getEmployeesOcupationalMedical(response.id)
              .then((res) => {
                let informacion = res.employee
                this.usersList = informacion
              })
          })
          .catch((error) => {
            console.log(error);
          });
      },

      getItemData() {
        ItemAPI.getItems(32)
          .then((response) => {
            this.itemData = response;
          })
          .catch((error) => {
            console.log(error);
          });
      },

      goPage(page) {
        window.location.href = page
      },

      goBack() {
        this.$router.go(-1);
      },

      dateConvert(date) {
        return dateFormat(date);
      },

    },

    mounted() {
      this.getUsers();
      this.getItemData();
      this.getList();
    }
  }

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div class="col-xl-12" v-if="!loading1 && classificationID <= 4">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Reportar ante la ARL los accidentes e incidentes y enfermedades laborales y subir a este
                      aplicativo, la evidencia de dicho formulario, radicado en la ARL. Estos reportes se deben realizar
                      durante los dos días hábiles siguientes al evento.
                      De igual manera, se deberá reportar a la EPS del colaborador accidentado. Cuando son accidentes
                      graves o mortales, o se califica una enfermedad laboral, se deberá notificar a la Dirección
                      Territorial del Ministerio de Trabajo.
                      Subir en un archivo comprimido todas las evidencias de estas notificaciones.
                    </p>
                  </CheckModal>
                </div>
              </div>

              <form :disabled="!getRole('Crear') || !allowAccess()" class="form-group" @submit.prevent="save">
                <!-- check for accidents -->
                <div class="form-row">
                  <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                      <b-form-input disabled v-model="noAccidents.report_date"
                        type="date" id="input-sm" placeholder="fecha" :class="{
                          'is-invalid':
                            $v.noAccidents.report_date.$error && submitted,
                        }">

                      </b-form-input>
                      <div v-if="submitted && $v.noAccidents.report_date.$error">
                        <small v-if="!$v.noAccidents.report_date.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>

                    <b-form-group class="col-md-6" label="Descripción" label-for="input-sm">
                      <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea"
                        v-model="noAccidents.description" maxlength="100" rows="4" :class="{
                          'is-invalid':
                            $v.noAccidents.description.$error && submitted,
                        }">
                      </b-form-textarea>
                      <div v-if="submitted && $v.noAccidents.description.$error">
                        <small v-if="!$v.noAccidents.description.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="!getRole('Crear') || !allowAccess()" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />
                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">

                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading">
                          <table :disabled="!getRole('Consultar') || !allowAccess()" class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Fecha</th>
                                <th class="text-center align-middle">Descripción</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr :disabled="!getRole('Consultar') || !getRole('Editar') || !allowAccess()"
                                v-for="dato in lista" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.report_date }}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.description }}
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <div>
                                      <button class="btn btn-outline-primary" :disabled="!getRole('Eliminar') || !allowAccess()"
                                        v-on:click="deleteAccident(dato.id)">
                                        Eliminar
                                      </button>                                  
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </form>

            </div>
          </div>
        </div>

        <div v-else-if="!loading1 && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading1">
          <DontExist />
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>


      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .background-modal {
    background-color: transparent !important;
    border: none;
  }
</style>